import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Traduce un codice paese ISO-3166 alpha-2 (es. il `userFlag` di una recensione)
 * nel nome del paese nella lingua attiva, usando le chiavi `country.<CODICE>`
 * generate staticamente nei file i18n (vedi scripts/generate-country-i18n.cjs).
 *
 * Impure come la pipe `translate` di ngx-translate: si riallinea al cambio lingua
 * e al caricamento asincrono dei file i18n. Se il codice manca o non è mappato,
 * ripiega sul `fallback` (tipicamente review.nationality, il nome in inglese dal DB).
 */
@Pipe({ name: 'countryName', standalone: true, pure: false })
export class CountryNamePipe implements PipeTransform {
  constructor(private readonly translate: TranslateService) {}

  transform(isoCode?: string | null, fallback?: string | null): string {
    if (!isoCode) {
      return fallback ?? '';
    }
    let code = isoCode.toUpperCase();
    if (code === 'EN') {
      code = 'GB'; // 'en' è usato come codice bandiera per il Regno Unito
    }
    const key = `country.${code}`;
    const translated = this.translate.instant(key);
    return translated && translated !== key ? translated : (fallback ?? isoCode);
  }
}
